import { OnboardingStatus, STATUS } from "../App.constants";
import { ONBOARDING_STATUS_KEY } from "../components/providers/authProvider";

/**
 * User can create new orders only when:
 * - World Check status is LOW_RISK, and
 * - Onboarding status is not RESTRICTED (Restricted users can login but cannot create new orders).
 * Same behavior as when World Check status is not Low Risk.
 */
export function canCreateNewOrder(): boolean {
  const statusUser = localStorage.getItem("status_user");
  const onboardingStatus = localStorage.getItem(ONBOARDING_STATUS_KEY);
  const isLowRisk = statusUser === STATUS.LOW_RISK;
  const isRestricted = onboardingStatus === OnboardingStatus.RESTRICTED;
  return Boolean(isLowRisk && !isRestricted);
}
